import { render } from "./StartBackup.vue?vue&type=template&id=731e1036&scoped=true"
import script from "./StartBackup.vue?vue&type=script&lang=js"
export * from "./StartBackup.vue?vue&type=script&lang=js"

import "./StartBackup.vue?vue&type=style&index=0&id=731e1036&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731e1036"]])

export default __exports__